module.exports = __webpack_public_path__ + "img/login-icon2.caf1af93.png";